var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 45,
    viewBox: "0 0 35 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 40C2.50396 41.3249 3.03201 42.5943 3.96884 43.5312C4.90566 44.468 6.17513 44.996 7.5 45H27.5C28.8249 44.996 30.0943 44.468 31.0312 43.5312C31.968 42.5943 32.496 41.3249 32.5 40V15C32.496 13.6751 31.968 12.4057 31.0312 11.4688C30.0943 10.532 28.8249 10.004 27.5 10H7.5C6.17513 10.004 4.90566 10.532 3.96884 11.4688C3.03201 12.4057 2.50396 13.6751 2.5 15V40ZM32.5 2.5H26.25L24.475 0.725C24.008 0.26517 23.3804 0.00515083 22.725 0H12.275C11.6196 0.00515083 10.992 0.26517 10.525 0.725L8.75 2.5H2.5C1.83696 2.5 1.20107 2.76339 0.732234 3.23223C0.263393 3.70107 0 4.33696 0 5C0 5.66304 0.263393 6.29893 0.732234 6.76777C1.20107 7.23661 1.83696 7.5 2.5 7.5H32.5C33.163 7.5 33.7989 7.23661 34.2678 6.76777C34.7366 6.29893 35 5.66304 35 5C35 4.33696 34.7366 3.70107 34.2678 3.23223C33.7989 2.76339 33.163 2.5 32.5 2.5Z",
    fill: "#FE4C4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.08f9b0ac789a8a7f6576339f2f03e869.svg";
export { ForwardRef as ReactComponent };